import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faUserShield, faUser } from '@fortawesome/free-solid-svg-icons';

const Sidebar = () => {
  const location = useLocation();
  const admin = JSON.parse(localStorage.getItem('admin') || '{}');

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <Nav className="flex-column bg-dark text-white" style={{ minHeight: '100vh', width: '250px' }}>
      <div className="p-3">
        <h4>Church Members</h4>
      </div>
      <Nav.Link
        as={Link}
        to="/members"
        className={`text-white ${isActive('/members') ? 'active' : ''}`}
      >
        <FontAwesomeIcon icon={faUsers} className="me-2" />
        Members
      </Nav.Link>
      {admin.role === 'super_admin' && (
        <Nav.Link
          as={Link}
          to="/admins"
          className={`text-white ${isActive('/admins') ? 'active' : ''}`}
        >
          <FontAwesomeIcon icon={faUserShield} className="me-2" />
          Administrators
        </Nav.Link>
      )}
      <Nav.Link
        as={Link}
        to="/profile"
        className={`text-white ${isActive('/profile') ? 'active' : ''}`}
      >
        <FontAwesomeIcon icon={faUser} className="me-2" />
        Profile
      </Nav.Link>
    </Nav>
  );
};

export default Sidebar; 